/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_ReadInputs */

const es_tools_nexata_file_read = /** @type {(inputs: Tools_Nexata_File_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo archivo...`)
};

const en_tools_nexata_file_read = /** @type {(inputs: Tools_Nexata_File_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading file...`)
};

/**
* | output |
* | --- |
* | "Reading file..." |
*
* @param {Tools_Nexata_File_ReadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_read = /** @type {((inputs?: Tools_Nexata_File_ReadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_ReadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_read(inputs)
	return en_tools_nexata_file_read(inputs)
});
export { tools_nexata_file_read as "tools.nexata.file_read" }